import { AgGridColumnType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import { StatisticalAnalysisViewDetailChartFilterAxisCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-filters-axis/statistical-analysis-view-detail-chart-filters-axis.model'
import { StatisticalAnalysisExternalListCase, StatisticalAnalysisExternalListColumnsCases } from '@/modules/statistical-analysis-module/shared/external-list-columns/external-list-columns-cases'
import { StatisticalAnalysisExternalListPortion, StatisticalAnalysisExternalListPortions } from '@/modules/statistical-analysis-module/shared/external-list-columns/external-list-columns-portions'
import { StatisticalAnalysisExternalListSample, StatisticalAnalysisExternalListSamples } from '@/modules/statistical-analysis-module/shared/external-list-columns/external-list-columns-samples'
import { StatisticalAnalysisExternalListSubportion, StatisticalAnalysisExternalListSubportions } from '@/modules/statistical-analysis-module/shared/external-list-columns/external-list-columns-subportions'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisComboPreselections, StatisticalAnalysisComboTypes, StatisticalAnalysisDossiersDatasourceResponsesDetailTypes, StatisticalAnalysisDynamicObject, StatisticalAnalysisExternalListTypes, StatisticalAnalysisViewDetailTableGroupingColumns } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { Nullable } from '@/shared/types/app.types'
import { ColDef, ColGroupDef } from '@ag-grid-enterprise/all-modules'
import { find, isArray } from 'lodash'

export const getExternalColumnsEntity = (entity: StatiscalAnalysisTypeCases): ColDef[] | ColGroupDef[] | ExportedColGroupDef[] | ExportedColDef [] => {
    // TODO Here the columns for the new entities will be added
    switch (entity) {
    case StatiscalAnalysisTypeCases.CASE:
        return [{ type: AgGridColumnType.CUSTOM_CHECKBOX } as ColDef].concat(StatisticalAnalysisExternalListColumnsCases())
    case StatiscalAnalysisTypeCases.SAMPLE:
        return [{ type: AgGridColumnType.CUSTOM_CHECKBOX } as ColDef].concat(StatisticalAnalysisExternalListSamples())
    case StatiscalAnalysisTypeCases.PORTION:
        return [{ type: AgGridColumnType.CUSTOM_CHECKBOX } as ColDef].concat(StatisticalAnalysisExternalListPortions())
    case StatiscalAnalysisTypeCases.SUBPORTION:
        return [{ type: AgGridColumnType.CUSTOM_CHECKBOX } as ColDef].concat(StatisticalAnalysisExternalListSubportions())
    default: return []
    }
}

export const getIconHeaders = (entity: StatiscalAnalysisTypeCases): string => {
    switch (entity) {
    case StatiscalAnalysisTypeCases.CASE:
        return 'far fa-chart-network'
    case StatiscalAnalysisTypeCases.SAMPLE:
        return 'far fa-prescription-bottle'
    case StatiscalAnalysisTypeCases.PORTION:
        return 'icon-block'
    case StatiscalAnalysisTypeCases.SUBPORTION:
        return 'icon-porta'
    case StatiscalAnalysisTypeCases.REQUEST:
        return 'far fa-file-medical'
    case StatiscalAnalysisTypeCases.PATIENT:
        return 'far fa-users'
    default: return ''
    }
}

export const getXAxisPreselections = (preselection: Nullable<StatisticalAnalysisViewDetailChartFilterAxisCombo>, entity: (StatiscalAnalysisTypeCases | StatiscalAnalysisTypeCases[]), combo: StatisticalAnalysisViewDetailChartFilterAxisCombo[], nameCombo: StatisticalAnalysisComboTypes): StatisticalAnalysisViewDetailChartFilterAxisCombo => {
    if (isArray(entity)) {
        if (nameCombo === StatisticalAnalysisComboTypes.MAIN) {
            return find(combo, { id: preselection?.id }) || combo[0]
        } else {
            return find(combo, { id: preselection?.id }) || combo[1]
        }
    } else {
        switch (entity) {
        case StatiscalAnalysisTypeCases.CASE:
            if (nameCombo === StatisticalAnalysisComboTypes.MAIN) {
                return find(combo, { id: preselection?.id }) || find(combo, { id: StatisticalAnalysisComboPreselections.PATHOLOGIST }) || combo[0]
            } else {
                return find(combo, { id: preselection?.id }) || find(combo, { id: StatisticalAnalysisComboPreselections.CASE_TYPE }) || combo[1]
            }
        case StatiscalAnalysisTypeCases.SAMPLE:
            if (nameCombo === StatisticalAnalysisComboTypes.MAIN) {
                return find(combo, { id: preselection?.id }) || find(combo, { id: StatisticalAnalysisComboPreselections.SAMPLE_TYPE }) || combo[0]
            } else {
                return find(combo, { id: preselection?.id }) || find(combo, { id: StatisticalAnalysisComboPreselections.TOPOGRAPHIC_CODE }) || combo[1]
            }
        case StatiscalAnalysisTypeCases.PORTION:
            if (nameCombo === StatisticalAnalysisComboTypes.MAIN) {
                return find(combo, { id: preselection?.id }) || find(combo, { id: StatisticalAnalysisComboPreselections.PORTION_TYPE }) || combo[0]
            } else {
                return find(combo, { id: preselection?.id }) || find(combo, { id: StatisticalAnalysisComboPreselections.GENERATION_PERSONNEL }) || combo[1]
            }
        case StatiscalAnalysisTypeCases.SUBPORTION:
            if (nameCombo === StatisticalAnalysisComboTypes.MAIN) {
                return find(combo, { id: preselection?.id }) || find(combo, { id: StatisticalAnalysisComboPreselections.SUBPORTION_TYPE }) || combo[0]
            } else {
                return find(combo, { id: preselection?.id }) || find(combo, { id: StatisticalAnalysisComboPreselections.ASSAYS_GROUP }) || combo[1]
            }
        default:
            if (nameCombo === StatisticalAnalysisComboTypes.MAIN) {
                return find(combo, { id: preselection?.id }) || combo[0]
            } else {
                return find(combo, { id: preselection?.id }) || combo[1]
            }
        }
    }
}

export const getLabAndCaseId = (entity: StatiscalAnalysisTypeCases, selectedRow: StatisticalAnalysisExternalListTypes): [number, number] => {
    let caseId
    let laboratoryId
    switch (entity) {
    case StatiscalAnalysisTypeCases.CASE:
        caseId = (selectedRow as StatisticalAnalysisExternalListCase).caseId
        laboratoryId = (selectedRow as StatisticalAnalysisExternalListCase).laboratory.labId
        break
    case StatiscalAnalysisTypeCases.SAMPLE:
        caseId = (selectedRow as StatisticalAnalysisExternalListSample).caseStudy.caseId
        laboratoryId = (selectedRow as StatisticalAnalysisExternalListSample).caseStudy.laboratory.labId
        break
    case StatiscalAnalysisTypeCases.PORTION:
        caseId = (selectedRow as StatisticalAnalysisExternalListPortion).caseStudy.caseId
        laboratoryId = (selectedRow as StatisticalAnalysisExternalListPortion).caseStudy.laboratory.labId
        break
    case StatiscalAnalysisTypeCases.SUBPORTION:
        caseId = (selectedRow as StatisticalAnalysisExternalListSubportion).caseStudy.caseId
        laboratoryId = (selectedRow as StatisticalAnalysisExternalListPortion).caseStudy.laboratory.labId
        break
    default:
        caseId = (selectedRow as StatisticalAnalysisExternalListCase).caseId
        laboratoryId = (selectedRow as StatisticalAnalysisExternalListCase).laboratory.labId
        break
    }
    return [laboratoryId, caseId]
}

export const getSelectedRowsIds = (entity: StatiscalAnalysisTypeCases, selectedRows: StatisticalAnalysisDossiersDatasourceResponsesDetailTypes[]) : number[] => {
    let selectedIds
    switch (entity) {
    case StatiscalAnalysisTypeCases.CASE:
        selectedIds = (selectedRows as StatisticalAnalysisExternalListCase[]).map((selectedRow: StatisticalAnalysisExternalListCase) => selectedRow.caseId)
        break
    case StatiscalAnalysisTypeCases.SAMPLE:
        selectedIds = (selectedRows as StatisticalAnalysisExternalListSample[]).map((selectedRow: StatisticalAnalysisExternalListSample) => selectedRow.sampleId)
        break
    case StatiscalAnalysisTypeCases.PORTION:
        selectedIds = (selectedRows as StatisticalAnalysisExternalListPortion[]).map((selectedRow: StatisticalAnalysisExternalListPortion) => selectedRow.portionId)
        break
    case StatiscalAnalysisTypeCases.SUBPORTION:
        selectedIds = (selectedRows as StatisticalAnalysisExternalListSubportion[]).map((selectedRow: StatisticalAnalysisExternalListSubportion) => selectedRow.subportionId)
        break
    default:
        selectedIds = (selectedRows as StatisticalAnalysisExternalListCase[]).map((selectedRow: StatisticalAnalysisExternalListCase) => selectedRow.caseId)
        break
    }
    return selectedIds
}

export const parseGroupingParams = (aggr: StatisticalAnalysisDynamicObject, value: StatisticalAnalysisViewDetailTableGroupingColumns) => {
    if (value.groupedBy.includes('.')) {
        const group = value.groupedBy.split('.')
        return Object.assign(aggr, { [group?.[group.length - 1]]: value.value })
    } else {
        return Object.assign(aggr, { [value.groupedBy]: value.value })
    }
}
